/* Supplement server-rendered links; never submit forms or change prices/bookings. */
(function () {
  'use strict';
  function localizeHref(href, origin, root) {
    if (!href || /^(?:#|mailto:|tel:|javascript:|data:)/i.test(href)) return href;
    if (!/^(?:https?:\/\/|\/)/i.test(href)) return href;
    var url;
    try { url = new URL(href, origin); } catch (e) { return href; }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return href;
    var own = new URL(origin);
    if (url.origin !== own.origin && url.hostname !== 'mamomura.com' && url.hostname !== 'www.mamomura.com') return href;
    if (url.searchParams.has('mamo_lang') || url.searchParams.has('locale')) return href;
    var prefix = String(root || '').replace(/\/+$/, '');
    if (!/^\/(?:en|zh-hant|zh-tw)$/i.test(prefix)) return href;
    if (/^\/(?:ja|en|ko|zh-hant|zh-hans|zh-tw|zh-cn)(?:\/|$)/i.test(url.pathname)) return href;
    if (url.pathname !== '/' && !/^\/(?:pages|products|collections|blogs|policies|cart|search)(?:\/|$)/.test(url.pathname)) return href;
    return prefix + (url.pathname === '/' ? '' : url.pathname) + url.search + url.hash;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { localizeHref: localizeHref };
    return;
  }
  var loader = document.currentScript;
  var root = loader && loader.getAttribute('data-mm-root');
  if (!root || window.__mmLocaleLinksReady) return;
  window.__mmLocaleLinksReady = true;
  var excluded = '[data-mm-language-switch],[data-mm-home-lang],[data-mm-lang],[hreflang],[download],form[action*="localization"],#mm-home-language-entry';
  function update(anchor) {
    if (!anchor || !anchor.getAttribute || anchor.closest(excluded)) return;
    var old = anchor.getAttribute('href');
    var next = localizeHref(old, location.origin, root);
    if (next !== old) anchor.setAttribute('href', next);
  }
  function scan(node) {
    if (!node || !node.querySelectorAll) return;
    if (node.matches && node.matches('a[href]')) update(node);
    node.querySelectorAll('a[href]').forEach(update);
  }
  function start() {
    scan(document);
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.type === 'attributes') update(record.target);
          else record.addedNodes.forEach(scan);
        });
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) update(anchor);
  }, true);
  window.addEventListener('pageshow', function () { scan(document); });
})();
